import React, { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { 
    Box, 
    Tooltip, 
    Menu, 
    MenuItem, 
    styled,
    Button,
    Drawer,
} from '@mui/material';
import { grey } from '@mui/material/colors';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import HomeIcon from '@mui/icons-material/Home';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import SparkleIcon from '../../../assets/sparkle-icon.svg';
import Footer from '../../Misc/Footer';
import { setReportingABug } from '../../../redux/slices/shared/sharedSlice';
import { loginPhysician, logout } from '../../../redux/slices/auth/authThunk';
import CreateIcon from '@mui/icons-material/Create';

const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(grey[500]),
    border: `0.5px solid ${grey[500]}`,
    backgroundColor: grey[509],
    '&:hover': {
        backgroundColor: grey[200],
        borderColor: grey[500],
        color: grey[900]
    },
}));

export const ProfileMenuButton = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { loggedIn } = useSelector(state => state.auth);

    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const [termsAndConditionsOpen, setTermsAndConditionsOpen] = useState(false);

    const onQuestionnaire = window.location.href.includes("onboard/");
    const onProfile = window.location.href.includes("profile");
    const onNPI = window.location.href.includes("npi");
    /***
     * Close the menu
     * 
     * @param {Event} e
     */
    const handleClose = (e) => {
        e.preventDefault();
        //When the menu is closed, remove anchor element, close menu, and close terms and conditions
        setAnchorEl(null);
        setOpen(false);
        setTermsAndConditionsOpen(false);
    }

    /***
     * Toggle the menu and terms and conditions state
     * 
     * @param {Event} e
     */
    const handleClick = (e) => {
        e.preventDefault();
        setOpen(!open);
        setTermsAndConditionsOpen(!termsAndConditionsOpen);
        setAnchorEl(e.currentTarget);
    }

    /***
     * Navigate to home page
     * 
     * @param {Event} e
     */
    const onClickGoHome = (e) => {
        e.preventDefault();
        navigate("/");
    }

    /***
     * Open report a bug dialog
     * 
     * @param {Event} e
     */
    const onClickReportABug = async (e) => {
        e.preventDefault();
        dispatch(setReportingABug(true));
    }

    /***
     * Navigate to questionnaire
     * 
     * @param {Event} e
     */
    const onClickGoToSurvey = (e) => {
        e.preventDefault();
        navigate("/onboard/questionnaire/0")
    }

    /***
     * Login or logout depending on which the patient is on currently
     * 
     * @param {Event} e
     */
    const onClickLoginLogout = async (e) => {
        e.preventDefault();
        loggedIn ? await dispatch(logout()) : await dispatch(loginPhysician());
    }

    const onClickUpdateProfile = (e) => {
        e.preventDefault();
        navigate("/profile");
    }

    return (
        <>
        <Box>
            <Tooltip title="Account menu">
                <ColorButton 
                    variant="outlined" 
                    onClick={(e) => handleClick(e)} 
                >
                    <PersonOutlineIcon />
                </ColorButton>
            </Tooltip>
        </Box>
        <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            sx={{
                borderRadius: "0.25rem",
                height: "auto",
                width: "20rem",
                '& .MuiBackdrop-root': {height: "calc(100% - 8rem)", width: "100%"},
        }}>
            {onProfile ? 
                <MenuItem onClick={onClickGoHome}>
                    <HomeIcon sx={{ maxWidth: "1.5rem", maxHeight: "1.5rem", marginRight: "1.5rem"}}/> Home
                </MenuItem>
                :
                <MenuItem onClick={onClickUpdateProfile}>
                    <CreateIcon sx={{ maxWidth: "1.5rem", maxHeight: "1.5rem", marginRight: "1.5rem"}}/> Update Profile
                </MenuItem>
            }
            {onQuestionnaire ?
                <MenuItem onClick={onClickGoHome}>
                    <HomeIcon sx={{ maxWidth: "1.5rem", maxHeight: "1.5rem", marginRight: "1.5rem"}} /> Home
                </MenuItem>
                : 
                onNPI ? 
                    null
                    :
                    <MenuItem onClick={onClickGoToSurvey}>
                        <img src={SparkleIcon} alt="Sparkle Icon" style={{maxHeight: "3rem", margin: "-0.5rem 0.5rem -0.5rem -0.5rem" }}/>
                        Complete Questionnaire
                    </MenuItem>
            }
            {loggedIn && !onQuestionnaire &&
                <MenuItem onClick={async (e) => await onClickReportABug(e)}>
                    <ErrorOutlineIcon sx={{ maxWidth: "1.5rem", maxHeight: "1.5rem", marginRight: "1.5rem"}}/> Report a Bug
                </MenuItem>
            } 
            <MenuItem onClick={async (e) => await onClickLoginLogout(e)}>
                <AccountCircleIcon sx={{ maxWidth: "1.5rem", maxHeight: "1.5rem", marginRight: "1.5rem"}}/> {loggedIn ? "Logout" : "Login"}
            </MenuItem>
        </Menu>
        <Drawer open={termsAndConditionsOpen} anchor="bottom" sx={{position: "absolute", '& .MuiBackdrop-root': {display: "none !important"}}}>
            <Footer />
        </Drawer>
        
    </>
    )
}

export default ProfileMenuButton;